module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.4572c51e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-light-webfont.woff2
// module id = 494
// module chunks = 0